import type { NextPage } from 'next';
import { GetServerSideProps, GetStaticProps } from 'next';
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import generateRss from '../../lib/genereteRss';
import { useTranslation } from "next-i18next";
import { getAllPosts } from '../../lib/api';
import MainLayout from '../../components/layouts/MainLayout';
import { IPosts } from '../../interfaces/postsInterfaces';

import PostsSection from '../../components/sections/home/PostsWidget';
import { getAllTags } from '../../lib/getTags';



interface IPostsProps {
    locale: string;
    posts: IPosts[];
}

const Posts: NextPage<IPostsProps> = (props: IPostsProps) => {
    const { t } = useTranslation('home');
    const tags = getAllTags(props.posts);

    return (
        <MainLayout
            {...props}
            title={t('postsWidget.title')}
            description={t('postsWidget.subtitle')}
            keywords={Object.keys(tags).toString()}
        >
            <PostsSection
                pagination={true}
                title={t('postsWidget.title')}
                subtitle={t('postsWidget.subtitle')}
                {...props}
            />
        </MainLayout>
    )
}

export default Posts;

export const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale as string;
    const i18ln = { ...(await serverSideTranslations(locale, ['common','home'])) };

    const fields: Array<keyof IPosts> = [
        'slug',
        'title',
        'date',
        'description',
        'coverImage',
        'tags'
    ]

    const posts = getAllPosts(fields, locale);

    // rss
    if (posts.length > 0) {
        const rss = generateRss(posts, locale)
    }

    const limitPage = Number(process.env.appPageSize);
    const totalPages = Math.ceil(posts.length / limitPage);
    const currentPage = 1;

    return {
        props: {
            locale,
            ...i18ln,
            posts,
            limitPage,
            totalPages,
            currentPage
        }
    }
}